import { render, staticRenderFns } from "./EntriesProcedureUsers.vue?vue&type=template&id=af15022a&"
import script from "./EntriesProcedureUsers.vue?vue&type=script&lang=js&"
export * from "./EntriesProcedureUsers.vue?vue&type=script&lang=js&"
import style0 from "./EntriesProcedureUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports